<template>
  <div class="app-container">

    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="班级">
        <el-input v-model="formInline.searchTitle" placeholder="输入班级名称" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchExam">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="role == 3 || role == 2" :title="diaTitle" type="primary" @click="dialogTableVisible = true">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="role == 2" type="primary" @click="joinClassVisible = true">加入班级</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button v-if="role == 3 || role == 2" type="primary" @click="addStudentVisible = true">添加学生</el-button>
      </el-form-item> -->
    </el-form>

    <!-- table -->
    <el-table :data="data.records" border fit highlight-current-row :header-cell-style="{
      background: '#f2f3f4',
      color: '#555',
      'font-weight': 'bold',
      'line-height': '32px',
    }">
      <el-table-column align="center" type="selection" width="55" />
      <el-table-column label="序号" align="center" width="80px"><template slot-scope="scope">{{ scope.$index + 1 }}</template></el-table-column>
      <el-table-column prop="gradeName" label="班级名称" align="center" />
      <el-table-column prop="gradeCount" label="班级人数" align="center" />
      <el-table-column prop="code" label="班级口令" align="center" />
      <!-- <el-table-column prop="userName" label="创建用户" align="center" /> -->
      <el-table-column align="center" label="操作">
        <template slot-scope="{ row }">
          <!-- 管理员按钮 -->
          <el-button v-if="role == 3" type="text" size="small" style="font-size: 14px" @click="updateRow(row)">编辑</el-button>
          <el-button v-if="role == 3" type="text" size="small" style="color: red; font-size: 14px" @click="delClass(row)">删除</el-button>
          <!-- 教师按钮 -->
          <el-button v-if="role == 3 || role == 2" type="text" size="small" style="font-size: 14px" @click="updateRow(row)">编辑</el-button>
          <el-button v-if="role == 3 || role == 2" type="text" size="small" style="font-size: 14px" @click="showClass(row)">查看班级</el-button>
          <el-button v-if="role == 3 || role == 2" type="text" size="small" style="font-size: 14px" @click="showAddStudentDialog(row)">添加学生</el-button>
          <el-button v-if="role == 2" type="text" size="small" style="color: red; font-size: 14px" @click="exitClass(row)">退出班级</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination :current-page="data.current" :page-sizes="[10, 20, 30, 40]" :page-size="data.size"
        layout="total, sizes, prev, pager, next, jumper" :total="data.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
    <!--新增弹窗-->

    <el-dialog :title="diaTitle" :visible.sync="dialogTableVisible">
      <el-row>
        <el-form :model="addForm">
          <el-form-item label="班级名称" :label-width="formLabelWidth">
            <el-input v-model="addForm.gradeName" autocomplete="off" />
          </el-form-item>
        </el-form>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="addClass">确 定</el-button>
        <el-button type="primary" @click="importStudent">导入名单</el-button>
      </div>
    </el-dialog>

    <el-dialog title="加入班级" :visible.sync="joinClassVisible">
      <el-row>
        <el-form :model="teacharForm">
          <el-form-item label="班级代码：" :label-width="formLabelWidth">
            <el-input v-model="teacharForm.classCode" autocomplete="off" />
          </el-form-item>
        </el-form>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="joinClassVisible = false">取 消</el-button>
        <el-button type="primary" @click="joinClass">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加学生到班级对话框 -->
    <el-dialog title="添加学生到班级" :visible.sync="addStudentVisible" width="60%">
      <el-row>
        <el-form :model="addStudentForm">
          <el-form-item label="班级名称：" :label-width="formLabelWidth">
            <el-input v-model="addStudentForm.gradeName" :disabled="true" />
          </el-form-item>

          <!-- 添加方式选择 -->
          <el-form-item label="添加方式：" :label-width="formLabelWidth">
            <el-radio-group v-model="addStudentMode">
              <el-radio label="search">搜索学号</el-radio>
              <el-radio label="select">从学生列表选择</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 搜索学号方式 -->
          <el-form-item v-if="addStudentMode === 'search'" label="学校：" :label-width="formLabelWidth">
            <el-select v-model="addStudentForm.schoolName" placeholder="请选择学校" style="width: 100%" filterable @change="onSchoolChange">
              <el-option
                v-for="school in schoolList"
                :key="school"
                :label="school"
                :value="school">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="addStudentMode === 'search'" label="学生学号：" :label-width="formLabelWidth">
            <el-input v-model="addStudentForm.username" placeholder="请输入学生的学号" autocomplete="off" :disabled="!addStudentForm.schoolName" />
          </el-form-item>

          <!-- 从学生列表选择方式 -->
          <el-form-item v-if="addStudentMode === 'select'" label="选择学生：" :label-width="formLabelWidth">
            <el-select v-model="addStudentForm.selectedStudentId" placeholder="请选择学生" style="width: 100%" filterable>
              <el-option
                v-for="student in unassignedStudents"
                :key="student.id"
                :label="`${student.realName} (${student.userName}) - ${student.school || '未填写学校'}`"
                :value="student.id">
                <span style="float: left">{{ student.realName }} ({{ student.userName }})</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ student.school || '未填写学校' }}</span>
              </el-option>
            </el-select>
            <div style="margin-top: 10px; text-align: right;">
              <el-button size="small" @click="loadUnassignedStudents">刷新学生列表</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addStudentVisible = false">取 消</el-button>
        <el-button type="primary" @click="addStudentToClass">确 定</el-button>
      </div>
    </el-dialog>

    <!--编辑弹窗-->
    <el-dialog title="编辑" :visible.sync="dialogFormVisible">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form :model="form">
            <el-form-item label="班级名称" :label-width="formLabelWidth">
              <el-input v-model="form.gradeName" autocomplete="off" />
              <span style="margin-left: 10px; color: #909399; font-size: 12px;">班级ID: {{ form.gradeId || form.id }}</span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateClass">确 定</el-button>
        <el-button type="primary" @click="importStudent">导入名单</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导入学生名单" :visible.sync="uploadExcelVisible">
      <el-upload class="upload-demo" drag :action="importExcelUrl" :on-success="handleExcelSuccess"
        :on-error="handleExcelError" :before-upload="beforeExcelUpload" :file-list="excelFileList" accept=".xlsx, .xls">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">仅支持Excel文件（.xls/.xlsx），最大5MB</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadExcelVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleExcelUpload">上 传</el-button>
      </div>
    </el-dialog>

    <!-- 查看班级学生名单弹窗 -->
    <el-dialog title="班级学生名单" :visible.sync="showClassVisible" width="1000px">
      <el-table v-loading="studentListLoading" :data="studentList" border stripe style="width: 100%">
        <el-table-column label="序号" type="index" width="60" align="center" />
        <el-table-column prop="realName" label="姓名" align="center" />
        <el-table-column prop="userName" label="学号" align="center" />
        <el-table-column prop="school" label="学校" align="center" />
        <el-table-column prop="major" label="年级" align="center" />
        <el-table-column prop="parentPhone" label="家长电话" align="center" />
        <el-table-column prop="enrolledAt" label="注册时间" align="center">
          <template slot-scope="scope">
            {{ formatTime(scope.row.enrolledAt) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editStudent(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: red" @click="removeStudent(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showClassVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 编辑学生信息弹窗 -->
    <el-dialog title="编辑学生信息" :visible.sync="editStudentVisible" width="500px">
      <el-form :model="editStudentForm" :rules="editStudentRules" ref="editStudentForm" label-width="100px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="editStudentForm.name" placeholder="请输入学生姓名" />
        </el-form-item>
        <el-form-item label="学号" prop="studentId">
          <el-input v-model="editStudentForm.studentId" placeholder="请输入学号" disabled />
        </el-form-item>
        <el-form-item label="学校" prop="schoolName">
          <el-input v-model="editStudentForm.schoolName" placeholder="请输入学校名称" />
        </el-form-item>
        <el-form-item label="年级" prop="grade">
          <el-input v-model="editStudentForm.grade" placeholder="请输入年级" />
        </el-form-item>
        <el-form-item label="班级" prop="className">
          <el-input v-model="editStudentForm.className" placeholder="请输入班级名称" />
        </el-form-item>
        <el-form-item label="家长电话" prop="parentPhone">
          <el-input v-model="editStudentForm.parentPhone" placeholder="请输入家长电话" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editStudentVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveStudentInfo" :loading="saveStudentLoading">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { teacherJoinClass, teacherExitClass, classPaging, classDel, classUpdate, fetchClass, classAdd, addStudentToClass, addStudentToClassBySchool, getAllSchoolNames, getUnassignedStudents, removeStudentFromClass, updateStudentInfo } from '@/api/class'
// import { createGrade } from '@/api/grade'
import { getRole } from '@/utils/jwtUtils'
export default {
  data() {
    return {
      uploadExcelVisible: false,
      excelFileList: [],
      excelFile: null,
      importExcelUrl: '/api/class/importStudent', // 实际接口地址需根据后端调整
      teacharForm: {
        classCode: ''
      },
      addStudentVisible: false,
      addStudentMode: 'search', // 添加方式：search(搜索) 或 select(选择)
      addStudentForm: {
        gradeId: null,
        gradeName: '',
        username: '',
        schoolName: '',
        selectedStudentId: null
      },
      unassignedStudents: [], // 未加入班级的学生列表
      schoolList: [], // 学校列表
      role: 0,
      pageNum: 1,
      pageSize: 10,
      data: {},
      diaTitle: '新增',
      joinClassVisible: false,
      dialogTableVisible: false,
      dialogFormVisible: false,
      addForm: {
        gradeName: ''
      },
      formInline: {
        searchTitle: ''
      },
      form: {
        gradeName: ''
      },
      formLabelWidth: '110px',
      // 学生名单相关
      showClassVisible: false,
      studentList: [],
      studentListLoading: false,
      currentClassName: '',
      currentClassId: null,
      // 编辑学生信息相关
      editStudentVisible: false,
      editStudentForm: {
        id: null,
        name: '',
        studentId: '',
        schoolName: '',
        grade: '',
        className: '',
        parentPhone: ''
      },
      editStudentRules: {
        name: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' }
        ]
      },
      saveStudentLoading: false
    }
  },

  created() {
    this.getClassPage()
    this.role = getRole()
  },
  methods: {
    // 上传前校验
    beforeExcelUpload(file) {
      const isExcel = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isExcel) {
        this.$message.error('请上传Excel格式文件')
      }
      if (!isLt5M) {
        this.$message.error('文件大小不能超过5MB')
      }
      this.excelFile = file // 保存文件对象
      return isExcel && isLt5M
    },

    // 手动上传处理
    handleExcelUpload() {
      if (!this.excelFile) {
        return this.$message.error('请先选择文件')
      }
      const formData = new FormData()
      formData.append('file', this.excelFile)
      importStudentApi(formData).then(res => { // 假设后端接口接收FormData格式
        if (res.code === 200) {
          this.uploadExcelVisible = false
          this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
          this.$message.success('学生名单导入成功')
        } else {
          this.$message.error(`导入失败：${res.msg}`)
        }
      })
    },

    // 上传成功回调（如果使用自动上传）
    handleExcelSuccess(res, file) {
      this.$message.success('上传成功')
    },

    // 上传失败回调
    handleExcelError(err, file) {
      this.$message.error('上传失败，请重试')
    },
    importStudent() {
      this.uploadExcelVisible = true
      this.excelFileList = [] // 清空文件列表
    },
    joinClass() {
      const params = { code: this.teacharForm.classCode }
      teacherJoinClass(params).then((res) => {
        if (res.code) {
          this.joinClassVisible = false
          this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
          this.$message({
            type: 'success',
            message: '加入成功!'
          })
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    exitClass(row) {
      const classId = row['id']
      teacherExitClass(classId).then((res) => {
        if (res.code) {
          this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
          this.$message({
            type: 'success',
            message: '加入成功!'
          })
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    showClass(row) {
      const classId = row['id']
      this.currentClassName = row.gradeName
      this.currentClassId = classId
      this.studentListLoading = true
      this.showClassVisible = true
      this.studentList = []

      // 调用API获取班级学生名单
      fetchClass(classId).then((res) => {
        this.studentListLoading = false
        if (res.code) {
          this.studentList = res.data || []
          if (this.studentList.length === 0) {
            this.$message({
              type: 'info',
              message: '该班级暂无学生!'
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: res.msg || '获取学生名单失败'
          })
        }
      }).catch(() => {
        this.studentListLoading = false
        this.$message({
          type: 'error',
          message: '获取学生名单失败'
        })
      })
    },
    // 分页查询
    async getClassPage(pageNum, pageSize, title = null) {
      const params = { pageNum: pageNum, pageSize: pageSize, gradeName: title }
      const res = await classPaging(params)
      this.data = res.data
    },
    addClass() {
      const data = { gradeName: this.addForm.gradeName }
      classAdd(data).then((res) => {
        if (res.code) {
          this.addForm.gradeName = ''
          this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
          this.dialogTableVisible = false
          this.$message({
            type: 'success',
            message: '新增成功!'
          })
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    delClass(row) {
      this.$confirm('此操作将永久删除该班级, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          classDel(row.id).then((res) => {
            if (res.code) {
              this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    updateClass() {
      // 主页班级管理页面，form.id 就是班级表的ID
      console.log('编辑班级信息:', {
        form: this.form,
        classId: this.form.id,
        gradeName: this.form.gradeName
      })

      classUpdate(this.form.id, { gradeName: this.form.gradeName })
        .then((res) => {
          if (res.code) {
            this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: '编辑成功!'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消编辑'
          })
        })
    },
    updateRow(row) {
      this.dialogFormVisible = true
      this.form = row
    },
    searchExam() {
      this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
    },
    handleClick(row) {
      // TODO: 处理行点击事件
      console.log('Row clicked:', row)
    },
    handleSizeChange(val) {
      // 设置每页多少条逻辑
      this.pageSize = val
      this.getClassPage(this.pageNum, val)
    },
    handleCurrentChange(val) {
      // 设置当前页逻辑
      this.pageNum = val
      this.getClassPage(val, this.pageSize)
    },

    // 显示添加学生对话框
    showAddStudentDialog(row) {
      this.addStudentForm.gradeId = row.id
      this.addStudentForm.gradeName = row.gradeName
      this.addStudentForm.username = ''
      this.addStudentForm.schoolName = ''
      this.addStudentForm.selectedStudentId = null
      this.addStudentMode = 'search'
      this.addStudentVisible = true
      // 加载学校列表和学生列表
      this.loadSchoolList()
      this.loadUnassignedStudents()
    },

    // 添加学生到班级
    addStudentToClass() {
      if (this.addStudentMode === 'search') {
        // 搜索学号方式
        if (!this.addStudentForm.schoolName) {
          this.$message.warning('请选择学校')
          return
        }
        if (!this.addStudentForm.username.trim()) {
          this.$message.warning('请输入学生学号')
          return
        }

        // 使用新的API，根据学校+学号添加学生
        addStudentToClassBySchool(this.addStudentForm.gradeId, this.addStudentForm.username.trim(), this.addStudentForm.schoolName)
          .then((res) => {
            this.handleAddStudentSuccess(res)
          })
          .catch((error) => {
            this.handleAddStudentError(error)
          })
      } else if (this.addStudentMode === 'select') {
        // 从列表选择方式
        if (!this.addStudentForm.selectedStudentId) {
          this.$message.warning('请选择要添加的学生')
          return
        }
        // 根据选中的学生ID找到对应的用户名
        const selectedStudent = this.unassignedStudents.find(s => s.id === this.addStudentForm.selectedStudentId)
        if (!selectedStudent) {
          this.$message.error('选中的学生信息不存在')
          return
        }

        // 使用原有的API，根据学号添加学生
        addStudentToClass(this.addStudentForm.gradeId, selectedStudent.userName)
          .then((res) => {
            this.handleAddStudentSuccess(res)
          })
          .catch((error) => {
            this.handleAddStudentError(error)
          })
      }
    },

    // 处理添加学生成功
    handleAddStudentSuccess(res) {
      if (res.code) {
        this.addStudentVisible = false
        this.addStudentForm.username = ''
        this.addStudentForm.schoolName = ''
        this.addStudentForm.selectedStudentId = null
        this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
        // 刷新未加入班级的学生列表
        this.loadUnassignedStudents()
        this.$message({
          type: 'success',
          message: res.msg || '添加学生成功!'
        })
      } else {
        this.$message({
          type: 'error',
          message: res.msg || '添加学生失败'
        })
      }
    },

    // 处理添加学生失败
    handleAddStudentError(error) {
      console.error('添加学生失败:', error)
      this.$message({
        type: 'error',
        message: '添加学生失败，请稍后重试'
      })
    },

    // 加载学校列表
    loadSchoolList() {
      getAllSchoolNames()
        .then((res) => {
          if (res.code) {
            this.schoolList = res.data || []
          } else {
            console.error('获取学校列表失败:', res.msg)
            this.schoolList = []
          }
        })
        .catch((error) => {
          console.error('获取学校列表失败:', error)
          this.schoolList = []
        })
    },

    // 学校选择变化时的处理
    onSchoolChange() {
      // 清空学号输入框
      this.addStudentForm.username = ''
    },

    // 加载未加入班级的学生列表
    loadUnassignedStudents() {
      getUnassignedStudents()
        .then((res) => {
          if (res.code) {
            this.unassignedStudents = res.data || []
          } else {
            console.error('获取未加入班级学生列表失败:', res.msg)
            this.unassignedStudents = []
          }
        })
        .catch((error) => {
          console.error('获取未加入班级学生列表失败:', error)
          this.unassignedStudents = []
        })
    },

    // 编辑学生信息
    editStudent(row) {
      this.editStudentForm = {
        id: row.id,
        name: row.realName || '',
        studentId: row.userName || '',
        schoolName: row.school || '',
        grade: row.major || '',
        className: '',
        parentPhone: row.parentPhone || ''
      }
      this.editStudentVisible = true
    },

    // 保存学生信息
    saveStudentInfo() {
      this.$refs.editStudentForm.validate((valid) => {
        if (valid) {
          this.saveStudentLoading = true
          const studentData = {
            name: this.editStudentForm.name,
            schoolName: this.editStudentForm.schoolName,
            grade: this.editStudentForm.grade,
            className: this.editStudentForm.className,
            parentPhone: this.editStudentForm.parentPhone
          }

          updateStudentInfo(this.editStudentForm.id, studentData)
            .then((res) => {
              this.saveStudentLoading = false
              if (res.code === 1 || res.code === 200) {
                this.$message.success('学生信息更新成功')
                this.editStudentVisible = false
                // 刷新学生列表
                this.showClass({ id: this.currentClassId, gradeName: this.currentClassName })
              } else {
                this.$message.error(res.msg || '更新失败')
              }
            })
            .catch((error) => {
              this.saveStudentLoading = false
              console.error('更新学生信息失败:', error)
              this.$message.error('更新失败，请稍后重试')
            })
        }
      })
    },

    // 删除学生
    removeStudent(row) {
      this.$confirm(`确定要删除学生"${row.realName}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        removeStudentFromClass(this.currentClassId, row.id)
          .then((res) => {
            if (res.code === 1 || res.code === 200) {
              this.$message.success('学生已从班级中移除')
              // 刷新学生列表
              this.showClass({ id: this.currentClassId, gradeName: this.currentClassName })
            } else {
              this.$message.error(res.msg || '删除失败')
            }
          })
          .catch((error) => {
            console.error('删除学生失败:', error)
            this.$message.error('删除失败，请稍后重试')
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    }
  }
}
</script>

<style>
.el-table--border,
.el-table--group {
  border: 1px solid #b3b3b3;
}

.bj {
  margin-top: 40px;
  margin-left: 30px;
}
.upload-demo {
  width: 100%;
  text-align: center;
  padding: 30px 20px;
  border: 2px dashed #e0e0e0;
  border-radius: 6px;
  cursor: pointer;
}

.upload-demo .el-upload__text {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}

.upload-demo .el-upload__tip {
  margin-top: 5px;
  font-size: 12px;
  color: #999;
}
</style>
